import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import i18n from '../locales'

// 修复 vue-router 3.x 重复导航到当前路由时抛 NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
const routes = [
    { path: '/', redirect: '/Home', component: Home, meta: { titleKey: 'route.home' } },
    { path: '/Home', name: 'home', component: Home, meta: { titleKey: 'route.home' } },
    { path: '/Choose', name: 'choose', component: Choose, meta: { titleKey: 'route.choose' } },
    { path: '/List', name: 'list', component: List, meta: { titleKey: 'route.list' } },
    { path: '/Profile', name: 'profile', component: Profile, meta: { titleKey: 'route.profile' } },
    { path: '/Mine', name: 'mine', component: Mine, meta: { titleKey: 'route.mine' } },
    { path: '/Video', name: 'video', component: Video, meta: { titleKey: 'route.video' } },
    { path: '/Game', name: 'game', component: Game, meta: { titleKey: 'route.game' } },
    { path: '/Login', name: 'login', component: Login, meta: { titleKey: 'route.login' } },
    { path: '/Register', name: 'register', component: Register, meta: { titleKey: 'route.register' } },
    { path: '/ServiceOnline', name: 'ServiceOnline', component: ServiceOnline, meta: { titleKey: 'route.serviceOnline' } },
    { path: '/ServicePage', name: 'ServicePage', component: ServicePage, meta: { titleKey: 'route.servicePage' } },
    { path: '/Setting', name: 'Setting', component: Setting, meta: { titleKey: 'route.setting' } },
    { path: '/Infomation', name: 'Infomation', component: Infomation, meta: { titleKey: 'route.infomation' } },
    { path: '/Setname', name: 'Setname', component: Setname, meta: { titleKey: 'route.setname' } },
    { path: '/Setsex', name: 'Setsex', component: Setsex, meta: { titleKey: 'route.setsex' } },
    { path: '/SetPayPassword', name: 'SetPayPassword', component: SetPayPassword, meta: { titleKey: 'route.setPayPassword' } },
    { path: '/SetLoginPassword', name: 'SetLoginPassword', component: SetLoginPassword, meta: { titleKey: 'route.setLoginPassword' } },
    { path: '/Lottery', name: 'Lottery', component: Lottery, meta: { titleKey: 'route.lottery' } },
    { path: '/Notice', name: 'Notice', component: Notice, meta: { titleKey: 'route.notice' } },
    { path: '/PlayVideo', name: 'PlayVideo', component: PlayVideo, meta: { titleKey: 'route.playVideo' } },
    { path: '/Setbank', name: 'Setbank', component: Setbank, meta: { titleKey: 'route.setbank' } },
    { path: '/BindCard', name: 'BindCard', component: BindCard, meta: { titleKey: 'route.bindCard' } },
    { path: '/Withdraw', name: 'Withdraw', component: Withdraw, meta: { titleKey: 'route.withdraw' } },
    { path: '/Personalreport', name: 'Personalreport', component: Personalreport, meta: { titleKey: 'route.personalreport' } },
    { path: '/WithdrawRecord', name: 'WithdrawRecord', component: WithdrawRecord, meta: { titleKey: 'route.withdrawRecord' } },
    { path: '/GameRecord', name: 'GameRecord', component: GameRecord, meta: { titleKey: 'route.gameRecord' } },
];


//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to, from, next) => {
    const matched = to.matched[0]
    const meta = matched && matched.meta
    if (meta && meta.titleKey) {
        document.title = i18n.t(meta.titleKey)
    } else if (meta && meta.title) {
        document.title = meta.title
    }
    next()
})

export default router
